import styled from 'styled-components'
const isMobile = window.innerWidth < 712

const annoHeight = 120
const annoWidth = isMobile ? 80 : 120

export const TextAnnotation = ({
  pos,
  content,
  offset = { x: 0, y: 0 },
  width = isMobile ? 80 : 120,
  align,
}: {
  pos: { x: number; y: number }
  offset?: { x: number; y: number }
  content?: React.ReactNode
  width?: number
  align?: 'left' | 'right' | 'center'
}) => {
  return (
    <TextAnnotationRoot
      style={{
        left: pos.x + '%',
        top: pos.y + '%',
      }}
    >
      {/* {(offset.x !== 0 || offset.y !== 0) && <Marker />} */}
      <LineSVG
        style={{
          left: offset.x < 0 ? offset.x : 0,
          top: offset.y < 0 ? offset.y : 0,
          width: Math.abs(offset.x) + 1 + 'px',
          height: Math.abs(offset.y) + 1 + 'px',
        }}
      >
        <Line
          x1={offset.x <= 0 ? 0 : Math.abs(offset.x)}
          y1={offset.y <= 0 ? 0 : Math.abs(offset.y)}
          x2={offset.x <= 0 ? Math.abs(offset.x) : 0}
          y2={offset.y <= 0 ? Math.abs(offset.y) : 0}
        />
      </LineSVG>
      <ContentContainer
        style={{
          width: width + 'px',
          transform:
            offset.x === 0 ? 'translateX(calc(-50% - 15px))' : 'translateX(0)',
          justifyContent: align
            ? align === 'center'
              ? 'center'
              : align === 'right'
              ? 'flex-end'
              : 'flex-start'
            : offset.x === 0
            ? 'center'
            : offset.x < 0
            ? 'flex-end'
            : 'flex-start',
          textAlign: align
            ? align
            : offset.x === 0
            ? 'center'
            : offset.x < 0
            ? 'right'
            : 'left',
          alignItems: offset.y === 0 ? 'flex-start' : 'flex-end',
          paddingTop: offset.y === 0 ? '0' : '15px',
          paddingBottom: offset.y === 0 ? '0' : '15px',
          left: offset.x < 0 ? -width + offset.x - 15 + 'px' : offset.x + 15,
          top:
            offset.y === 0
              ? '-15px'
              : offset.y < 0
              ? offset.y - 45 + 'px'
              : offset.y,
        }}
      >
        {content}
      </ContentContainer>
    </TextAnnotationRoot>
  )
}

const Marker = styled.div.attrs({ className: 'Marker' })`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--text-color);
  position: absolute;
  top: -3px;
  left: -3px;
`
const ContentContainer = styled.div.attrs({ className: 'ContentContainer' })`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  line-height: 1.4em;
  font-size: 15px;
`

const TextAnnotationRoot = styled.div.attrs({ className: 'TextAnnotation' })`
  position: absolute;
  height: 0;
  width: 0;
  max-width: 100px;
  text-align: center;
  pointer-events: all;
  @media screen and (max-width: 711px) {
    max-width: 70px;
  }
`
const LineSVG = styled.svg.attrs({ className: 'LineSVG' })`
  position: absolute;
  top: 0;
`
const Line = styled.line.attrs({ className: 'Line' })`
  stroke: var(--text-color);
  stroke-width: 1px;
`
